import { useState } from 'react';

import Layout from '~/components/common/Layout';
import { ACTIVITY_LOG_ENTRY_TOP_LEVEL_ID } from '~/components/maud/tasks/TaskDetail/ActivityLogEntry';

import ClinicalMeasurementsModal, {
  ClinicalMeasurementModalData,
} from './clinical-measurement-modal/ClinicalMeasurementsModal';
import ClinicalMeasurementsOverview, {
  MeasurementCardDefinition,
} from './clinical-measurement-modal/ClinicalMeasurementsOverview';
import { useGetPatientClinicalProfileQuery } from '~/store/services/clinicalData';

interface ClinicalMeasurementProps {
  patient: Patient;
  patientId: string;
  patientPreferredFullName: string;
}

const ClinicalMeasurements = ({
  patient,
  patientId,
  patientPreferredFullName,
}: ClinicalMeasurementProps) => {
  const [showClinicalMeasurementModal, setShowClinicalMeasurementModal] =
    useState<ClinicalMeasurementModalData>(null);

  const [bmiCardData, setBmiCardData] =
    useState<MeasurementCardDefinition>(null);
  const [targetWeightCardData, setTargetWeightCardData] =
    useState<MeasurementCardDefinition>(null);
  const { data: patientClinicalProfile } = useGetPatientClinicalProfileQuery(
    patientId,
    {
      skip: !patientId,
    },
  );

  return (
    <Layout
      title="Clinical Measurements"
      titleId={`${ACTIVITY_LOG_ENTRY_TOP_LEVEL_ID}__clinical-measurements`}
    >
      <ClinicalMeasurementsOverview
        onClickCard={(profileType) =>
          setShowClinicalMeasurementModal({ profileType })
        }
        patient={patient}
        setBmiCardData={(data: MeasurementCardDefinition) =>
          setBmiCardData(data)
        }
        setTargetWeightCardData={(data: MeasurementCardDefinition) =>
          setTargetWeightCardData(data)
        }
      />
      <ClinicalMeasurementsModal
        bmiCardData={bmiCardData}
        closeModal={() => setShowClinicalMeasurementModal(null)}
        patient={patient}
        patientClinicalProfile={patientClinicalProfile}
        patientPreferredFullName={patientPreferredFullName}
        showClinicalMeasurementModal={showClinicalMeasurementModal}
        targetWeightCardData={targetWeightCardData}
      />
    </Layout>
  );
};

export default ClinicalMeasurements;
